import { AuthguardexistingService } from './service/authguardexisting.service';
import { AuthguardService } from './service/authguard.service';
import { MainComponent } from './main/main.component';
import { NumberOnlyDirective } from './Directives/number-only.directive';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { AppComponent } from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {MatButtonModule} from '@angular/material/button';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatCardModule} from '@angular/material/card';
import {MatIconModule} from '@angular/material/icon';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatMenuModule} from '@angular/material/menu';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatListModule} from '@angular/material/list';
import {MatTabsModule} from '@angular/material/tabs';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatTableModule} from '@angular/material/table';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { AppconfigService } from './service/appconfig.service';
import { HttpClientModule } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import { RouterModule, Routes } from '@angular/router';
import { StudentregistrationComponent } from './studentregistration/studentregistration.component';
import { BlockpasteDirective } from './Directives/blockpaste.directive';
import { NgxUpperCaseDirectiveModule } from 'ngx-upper-case-directive';
import { SavedialogComponent } from './savedialog/savedialog.component';
import { AlphaonlydirectiveDirective } from './Directives/alphaonlydirective.directive';
import { NgxLoadingModule } from 'ngx-loading';
import { ExistinguserdialogComponent } from './existinguserdialog/existinguserdialog.component';
import { UpdatedialogComponent } from './updatedialog/updatedialog.component';
import { OlduserComponent } from './olduser/olduser.component';
import { DownloadpdfComponent } from './downloadpdf/downloadpdf.component';
import { PoliciesComponent } from './POLICIES/policies/policies.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { NumberDirectiveDirective } from './Directives/number-directive.directive';
import { MatDialogModule } from '@angular/material/dialog';



export function initializeApp(appConfigdata: AppconfigService) {
  return () => appConfigdata.load();
}

const approutes: Routes = [
  {path: '', component: MainComponent},
  {path: 'main', component: MainComponent},
  {path: 'policies', component: PoliciesComponent,canActivate: [AuthguardService]},
  {path: 'studentreg', component: StudentregistrationComponent, canActivate: [AuthguardService]},
  {path: 'existingstudent', component: StudentregistrationComponent, canActivate: [AuthguardexistingService]},
  ];

@NgModule({
    declarations: [
        AppComponent,
        MainComponent,
        StudentregistrationComponent,
        NumberOnlyDirective,
        BlockpasteDirective,
        SavedialogComponent,
        AlphaonlydirectiveDirective,
        ExistinguserdialogComponent,
        UpdatedialogComponent,
        OlduserComponent,
        DownloadpdfComponent,
        PoliciesComponent,
        NumberDirectiveDirective,
    ],
    imports: [
        ReactiveFormsModule.withConfig({ warnOnNgModelWithFormControl: 'never' }),
        BrowserModule, RouterModule.forRoot(approutes, { useHash: true, relativeLinkResolution: 'legacy' }), NgxLoadingModule.forRoot({}),
        BrowserAnimationsModule, HttpClientModule, NgxUpperCaseDirectiveModule,
        MatButtonModule, MatCheckboxModule, FlexLayoutModule, MatToolbarModule, MatCardModule,
        MatIconModule, MatAutocompleteModule, MatFormFieldModule, MatInputModule, MatRadioModule,
        MatSelectModule, MatSlideToggleModule, MatMenuModule, MatSidenavModule, MatDividerModule,
        MatExpansionModule, MatGridListModule, MatListModule, MatTabsModule, MatProgressSpinnerModule, NgxSpinnerModule,
        MatTableModule, MatDatepickerModule, FormsModule, ReactiveFormsModule, MatSnackBarModule,
        MatDialogModule
    ],
    providers: [
        { provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [AppconfigService], multi: true }, AppconfigService, DatePipe
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule { }
